// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yZl2O","fullscreen":"Modal_fullscreen__2bwYq"};